(function () {
    'use strict';


    var extDeps = [];
    var module = angular.module('app.common.apis', extDeps);


    module.factory('NotificationsApi', NotificationsApi);
    NotificationsApi.$inject = ['$resource'];
    function NotificationsApi($resource) {
        return $resource('/api/notifications/:id', null, {
            markAsRead: {
                method: "PUT",
                params: {markAsRead: true, id: '@id'}
            }
            , getUnreadCount: {
                method: 'GET',
                params: {unread: true, v: new Date().toISOString() }
            }
            , query: {
                method:'GET'
                , cache:false
                , isArray:true
                , transformResponse:transformResponse
            }
        });


        function transformResponse(response){

            var rt = JSON.parse(response);
            rt.forEach(function(x){
                x.eventDate = new Date(x.eventDate);
            });

            return rt;
        }
    }


    module.factory('RostersApi', RostersApi);
    RostersApi.$inject = ['$resource','calendarEventsCache'];
    function RostersApi($resource, calendarEventsCache) {
        return $resource('/api/rosters', null, {
            query: {
                method: 'GET'
                , cache: calendarEventsCache
                , isArray: true
            }
        });
    }

    module.factory('RosterChangeApi', RosterChangeApi);
    RostersApi.$inject = ['$resource','calendarEventsCache'];
    function RosterChangeApi($resource,calendarEventsCache) {




        return $resource('/api/rosterchange'
            ,null
            ,{
                save: {
                    method: "POST"
                    , interceptor: geCalendarEventsCacheBusterInterceptor()
                    , transformRequest: transformRequest
                }
            });

        function transformRequest(data){
            var clone = angular.copy(data);
            clone.dateAppliedFor = moment(data.dateAppliedFor).format('YYYY-MM-DD');
            return angular.toJson(clone);
        }

        function geCalendarEventsCacheBusterInterceptor(){
            return {
                response: function(res){
                    calendarEventsCache.removeAll();
                    return res;
                }
            };
        }

    }

    module.factory('HeartbeatApi', HeartbeatApi);
    HeartbeatApi.$inject = ['$resource'];
    function HeartbeatApi($resource) {
        return $resource('/api/heartbeat', null, {
            update: {
                method: 'PUT'
            }
        });

        // return $resource('/api/news', {}, {
        //     update: {
        //         method: 'GET'
        //         , params: {id: getTimestamp }
        //         , cache: false
        //     }
        // });


        function getTimestamp(){
            return new Date().getTime();
        }

    }

    module.factory('NotesApi', NotesApi);
    NotesApi.$inject = ['$resource','moment','calendarEventsCache'];
    function NotesApi($resource,moment,calendarEventsCache) {
        return $resource(
            '/api/notes/:identifier'
            , { identifier: '@noteID' }
            , {
                create: {
                    method: "POST"
                    , transformRequest: transformRequest
                    , transformResponse:transformResponseSingle
                    , interceptor: geCalendarEventsCacheBusterInterceptor()
                }
                , update: {
                    method: "PUT"
                    , transformRequest: transformRequest
                    , transformResponse:transformResponseSingle
                    , interceptor: geCalendarEventsCacheBusterInterceptor()
                }
                , delete: {
                    method: "DELETE"
                    , interceptor: geCalendarEventsCacheBusterInterceptor()

                }
                , query: {
                    method:'GET'
                    , cache:false
                    , isArray:true
                    , transformResponse:transformResponse
                }
                , get: {
                    method:'GET'
                    , cache:false
                    , isArray:false
                    , transformResponse:transformResponseSingle
                }
        });

        function transformResponseSingle(response){
            var rt = transformResponse('[' + response + ']')[0];
            return rt;
        }

        function transformResponse(response){

            var rt = JSON.parse(response);
            rt.forEach(function(x){
                x.associatedDate = moment(new Date(x.associatedDate));
                x.lastUpdatedDate = moment(new Date(x.lastUpdatedDate));
            });

            return rt;
        }
 
        function transformRequest(data){
            var clone = angular.copy(data);
            clone.associatedDate = moment(data.associatedDate).format('YYYY-MM-DD');
            return angular.toJson(clone);
        }

        function geCalendarEventsCacheBusterInterceptor(){
            return {
                response: function(res){
                    calendarEventsCache.removeAll();
                    return res.data;
                }
            };
        }
    }


})();
